// ------------------------------------
// Imports
// ------------------------------------
import { formatErrorMessage, logApiError } from 'libs/notice';
// ------------------------------------
// Constants
// ------------------------------------
export const OPEN_NOTICE = 'OPEN_NOTICE';
export const CLOSE_NOTICE = 'CLOSE_NOTICE';
// ------------------------------------
// Actions
// ------------------------------------
/*
 * @export function openNotice
 * @returns {object} action opens the snackbar
 */
export function openNotice(payload) {
  return ({
    type: OPEN_NOTICE,
    payload
  });
}

/*
 * @export function notify
 * @param {string} message text to be shown at snack bar
 * @returns {object} action which opens the snackbar at the bottom of the app
 */
export function notify(value = {}) {
  const { error = {}, message } = value;
  logApiError(error);
  const errorMessage = formatErrorMessage(error);
  return (dispatch) => {
    dispatch(openNotice(message || errorMessage));
  };
}

/*
 * @export function closeNotice
 * @returns {object} action closes the snackbar
 */
export function closeNotice() {
  return {
    type: CLOSE_NOTICE
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/notice.js